export enum ROUTE_PATHS {
  login = '/login',
  wallets = '/wallets',
  accounts = '/accounts',
  reports = '/reports',
  mexcDistributor = '/mexc-distributor',
  project = '/project/:id',
  pair = '/project/:projectId/:venue/:pairId',
  dexPair = '/project/:projectId/dex-pair/:pairId',
  cexPair = '/project/:projectId/cex-pair/:pairId',
  solPair = '/project/:projectId/sol-pair/:pairId',
  arbitrage = '/project/:projectId/arbitrage/:arbitrageId',
  balancer = '/project/:projectId/balancer/:balancerId',
  balancerCreate = '/project/:projectId/balancer/create',
}
